function handles({ domain }) {
  return domain.endsWith('youtube.com') || domain === 'youtu.be';
}

export default handles;



// WEBPACK FOOTER //
// ./src/components/YoutubePost/handles.js